import React from 'react';
import styles from './Button.module.scss';

export type ButtonVariant =
  | 'primary'
  | 'secondary'
  | 'green'
  | 'greenLight'
  | 'greenOutline'
  | 'dark'
  | 'ghost'
  | 'blue'
  | 'danger';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant: ButtonVariant;
  size?: 'default' | 'sm' | 'badge';
  children: React.ReactNode;
}

/**
 * Ref-forwarding so callers can measure or focus the underlying element — {@link ActionMenu}
 * anchors its portalled menu to the trigger's bounding rect, and returns focus here on Escape.
 */
const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant, size = 'default', className, children, ...props },
  ref,
) {
  const sizeClass = size === 'sm' ? styles.sm : size === 'badge' ? styles.badge : '';
  const classes = [styles.btn, styles[variant], sizeClass, className].filter(Boolean).join(' ');

  return (
    <button ref={ref} className={classes} {...props}>
      {children}
    </button>
  );
});

export default Button;
